import { Link } from "react-router-dom";
import { formatBRL } from "@/lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const abs = (u) => (u?.startsWith("http") ? u : `${BACKEND}${u}`);

export default function ProductCard({ product }) {
  const first = (product.images && product.images[0]);
  const img = first ? abs(first) : "https://images.unsplash.com/photo-1611652022419-a9419f74343d?w=800";
  const hasSale = product.sale_price && product.sale_price < product.price;
  return (
    <Link
      to={`/produto/${product.slug || product.id}`}
      className="product-card group block"
      data-testid={`product-card-${product.id}`}
    >
      <div className="relative overflow-hidden bg-white aspect-[4/5]">
        <img
          src={img}
          alt={product.name}
          loading="lazy"
          className="product-img w-full h-full object-cover"
        />
        {hasSale && (
          <span className="absolute top-3 left-3 bg-[#49392F] text-white text-[10px] tracking-[0.25em] uppercase px-2 py-1">
            Oferta
          </span>
        )}
        {product.is_new && !hasSale && (
          <span className="absolute top-3 left-3 bg-[#C2A064] text-white text-[10px] tracking-[0.25em] uppercase px-2 py-1">
            Novo
          </span>
        )}
      </div>
      <div className="pt-4 pb-6">
        <div className="text-[10px] tracking-[0.25em] uppercase text-[#49392F]/60">{product.category}</div>
        <h3 className="font-display text-[17px] text-[#49392F] mt-1 leading-tight">{product.name}</h3>
        <div className="mt-2 flex items-baseline gap-2">
          {hasSale ? (
            <>
              <span className="text-[#49392F] font-medium">{formatBRL(product.sale_price)}</span>
              <span className="text-[12px] text-[#49392F]/50 line-through">{formatBRL(product.price)}</span>
            </>
          ) : (
            <span className="text-[#49392F] font-medium">{formatBRL(product.price)}</span>
          )}
        </div>
      </div>
    </Link>
  );
}
